import {
  Button,
  HStack,
  ScrollView,
  Text,
  Divider as UclDivider,
} from '@rbilabs/universal-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';

export const Container = ScrollView.withConfig({
  width: 'full',
  marginY: '$13.5',
});

export const TotalsRow = HStack.withConfig({
  width: 'full',
  paddingX: '$4',
});

export const TotalLabelTitle = Text.withConfig({
  flexGrow: 1,
  variant: 'copyOne',
  fontSize: 'md',
  fontWeight: 'bold',
});

export const TotalLabel = Text.withConfig({
  flexGrow: 1,
  variant: 'bodyOne',
});

export const Total = Text.withConfig({
  display: 'flex',
  variant: 'bodyOne',
});

export const Divider = UclDivider.withConfig({
  marginY: '$4',
  orientation: 'horizontal',
  thickness: '1',
});

export const DescriptionRow = Text.withConfig({
  flexGrow: 1,
  variant: 'bodyOne',
  paddingX: '$4',
  paddingTop: '$2',
  accessible: true,
  focusable: true,
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$4',
  height: '$4',
});

export const StyledLinkButton = Button.withConfig({
  variant: 'ghost',
  justifyContent: 'flex-start',
  _text: {
    variant: 'bodyOne',
    textDecorationLine: 'underline',
    fontSize: 'sm',
    selectable: false,
  },
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: Styles.color.tertiary,
      },
    },
  },
});
